import { useQuery } from "@tanstack/react-query";
import { ICobrancaDetailRetorno } from "@/models/consignado/proposal-billings.model";
import { buscarDetalheCobranca } from "@/services/consignado/proposta-cobranca.service";

// Detalhe da cobrança (GET /proposta/cobrancas/:id → ICobrancaDetailRetorno:
// id_proposta, competencias_resumo, motivo / comprovante de desligamento,
// taxa, status de renegociação…), pelo UUID que a listagem por CNPJ já devolve
// (`cobranca_id`, backend `d65c2b17`). É a rota pesada, então cada seção só
// liga quando precisa. Chave compartilhada: as seções de uma mesma CCB fazem
// uma chamada.
export const COBRANCA_DETALHE_QUERY_KEY = "cobranca-detalhe";

export function useCobrancaDetalhe(cobrancaId: string | null | undefined, enabled = true) {
  return useQuery<ICobrancaDetailRetorno>({
    queryKey: [COBRANCA_DETALHE_QUERY_KEY, cobrancaId],
    queryFn: () => buscarDetalheCobranca(cobrancaId!),
    enabled: enabled && !!cobrancaId,
    retry: 0,
    refetchOnWindowFocus: false,
  });
}
